import React, { useState, useEffect, JSX } from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    required,
    NumberInput,
    useNotify,
    useRedirect,
    SelectArrayInput,
    BooleanInput,
    useCreate,
    SelectInput
} from 'react-admin';
import { nokMiniTagChoices } from '../../defaults/defaults';
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const NokMiniCreate: () => JSX.Element = (): JSX.Element => {
    const selectChoices: { id: string, name: string }[] = [
        { id: 'disabled', name: 'Disabled' },
        { id: 'invitation', name: 'Invitation' },
        { id: 'available', name: 'Available' },
    ];
    const choices: { id: string, name: string }[] = nokMiniTagChoices;
    return (
        <Create redirect="edit">
            <SimpleForm>
                <TextInput name="name" source="name" validate={[required()]} fullWidth />
                <TextInput name="systemCode"
                           source="systemCode"
                           validate={[required()]}  />
                <TextInput name="description" source="description" fullWidth validate={[required()]} multiline  rows={24}/>
                <SelectInput source="status" choices={ selectChoices } />
                <SelectArrayInput
                    name="tags"
                    source="tags"
                    choices={ choices }
                    onCreate={ (): { id: string, name: string } => {
                        let newChoice: string = prompt("Enter new choice") ?? '';
                        if (newChoice.length > 0) {
                            newChoice = newChoice.replaceAll(' ', '_').toLowerCase();
                            const newChoiceOption = {
                                id: newChoice,
                                name: newChoice,
                            };
                            choices.push(newChoiceOption);
                            return newChoiceOption;
                        }
                    } }
                    createLabel="Create new option..."
                />
                <TextInput name="landingUrlKey" source="landingUrlKey" validate={[required()]} fullWidth />
                <TextInput name="landingDescription"
                           source="landingDescription"
                           fullWidth validate={[required()]}
                           multiline
                           rows={24}
                           helperText="Description rendered at top of landing page"
                />
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Create>
    );
}